var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYourConsumption(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#94A4F8",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.59754 9.00033C6.88805 8.97882 6.76908 10.002 7.46474 10.1425L8.74638 10.422C9.42433 13.6505 10.1633 16.8658 10.88 20.0862C10.9389 20.3502 11.1742 20.5381 11.4459 20.538H21.6231C22.4072 20.5496 22.4072 19.3727 21.6231 19.3842H11.9111L11.6545 18.2307H22.1366C22.4083 18.2308 22.6436 18.0429 22.7026 17.7789L23.9861 12.0104C24.0661 11.6503 23.7909 11.309 23.4205 11.3087C18.9864 11.3088 14.5523 11.3087 10.1182 11.3066L9.80319 9.81868C9.75624 9.59662 9.58289 9.42261 9.36026 9.37397L7.71228 9.01489C7.6746 9.00624 7.63621 9.00123 7.59758 9.00029L7.59754 9.00033ZM13.8582 20.9231C13.0116 20.9231 12.3128 21.6187 12.3128 22.4615C12.3128 23.3044 13.0116 24 13.8582 24C14.7048 24 15.4036 23.3044 15.4036 22.4615C15.4036 21.6187 14.7048 20.9231 13.8582 20.9231ZM19.267 20.9231C18.4204 20.9231 17.7216 21.6187 17.7216 22.4615C17.7216 23.3044 18.4204 24 19.267 24C20.1136 24 20.8123 23.3044 20.8123 22.4615C20.8123 21.6187 20.1136 20.9231 19.267 20.9231Z",
    fill: "#94A4F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourConsumption);
export default __webpack_public_path__ + "static/media/Your-consumption.f41ca57a.svg";
export { ForwardRef as ReactComponent };